<!--- Formulario frmManageShoppingLocationIndex ---->
<!---
Descripción del componente y comportamiento:
CASO DE USO:
* APP06_Gestionar Ubicación Compras
* https://grupohispatec.sharepoint.com/:w:/s/Produccin/EbRLToTQWz5CkDF3YejIaXIBtI7vfM83AEXhJfmMuCJsyg?e=PGajVl
---------------------------
- Formulario para Gestionar la ubicación de las compras.

Eventos escuchados por el formulario:
-----------------------

Eventos generados por el formulario:
-----------------------
-  XXXXXXX ->
--->

<template>
  <f7-page
    class="main-frmManageShoppingLocation"
  >
    <template #fixed>
      <TheNavbar
        nav-title="Gestionar ubicación Compras"
        :back-btn-enable="true"
        :back-callback="BackToMain"
        :style="appTheme"
      >
        <template #right>
          <div
            class="display-flex"
          >
            <f7-link
              @click="EventOpenReadBarCode"
            >
              <img
                class="img"
                :src="iconQr"
              >
            </f7-link>
          </div>
        </template>
      </TheNavbar>
    </template>
    <div class="padding-half header">
      <div
        v-if="!showPreload && locationList != null"
        class="margin-top-half"
      >
        <!-- Documento origen Albaran de compra -->
        <div
          v-if="locationList.TipoDocumentoOrigen === 1"
          class="header__texto limit-line "
        >
          <span class="header__texto--title">Albarán Compra:</span>
          <span class="header__texto--margin">{{ `${locationList.DocumentoOrigen.Serie}/${locationList.DocumentoOrigen.Numero}` }}</span>
        </div>
        <div
          v-if="locationList.TipoDocumentoOrigen === 1"
          class="header__texto limit-line"
        >
          <span class="header__texto--title">Proveedor:</span>
          <span class="header__texto--margin"> {{ locationList.DocumentoOrigen.Proveedor != null ? locationList.DocumentoOrigen.Proveedor.NombreProveedor : '' }}</span>
        </div>
        <!-- Sin documento de origen -->
        <div
          v-if="locationList.TipoDocumentoOrigen === 0"
          class="header__texto limit-line"
        >
          <span class="header__texto--title">Lista de Ubicaciones:</span>
          <span class="header__texto--margin"> {{ `${locationList.Serie}/${locationList.Numero}` }}</span>
        </div>
        <div
          class="header__texto limit-line"
        >
          <span class="header__texto--title">Estado:</span>
          <span class="header__texto--margin"> {{ estado }}</span>
        </div>
      </div>
    </div>
    <UCEmptyList
      v-if="locationList === null && !showPreload"
      class="emptyList"
      title="Sin documento seleccionado"
      subtitle="Pulse el botón para añadir un nuevo documento"
      :icon="iconQr"
      @click-icon="EventOpenReadBarCode"
    />

    <UCPreload :show="showPreload" />

    <div
      v-if="!showPreload && locationList != null && locationList.hasOwnProperty('Lineas') && locationList.Lineas != null && locationList.Lineas.length > 0"
      class="content-accordion"
    >
      <UCAcordeon
        :items="locationList.Lineas"
        name-element-item="items"
        badge-text-color="var(--his-oliva)"
        :opened-index="itemAcordeonOpen"
        :closed="true"
        :after-title="!disallowLocationAdvancement"
        :show-badge="false"
        :show-item-border-bottom="true"
        border-item-bottom-color="#E5EEF7"
        chevron-side="left"
        group-items
        group-key="Ubicacion.Id"
        @index-selected="EventAcordeonSelected"
      >
        <template
          #before="{ item }"
        >
          <img
            v-if="!ubicacionCompleta(item)"
            alt="iconEclipseOrange"
            src="@/static/img/ic_elipse_orange.svg"
          >
          <img
            v-if="ubicacionCompleta(item)"
            alt="iconEclipseGreen"
            src="@/static/img/ic_elipse_green.svg"
          >
        </template>
        <template
          #after="{ item }"
        >
          <img
            :src="iconDetail"
            @click="EventSelectedElemenParentAcordeon(item)"
          >
        </template>
        <template #titleOption="{ option }">
          <img
            v-if="option.items.filter(e => !e.UbicadoEnUbicacionPorDefecto).length > 0"
            class="padding-right-half"
            width="20"
            alt="iconWarning"
            src="@/static/icons/ic_warning.svg"
          >
          {{ option.group.Nombre }}
        </template>

        <template #subOption="{ item }">
          <f7-list-item
            media-list
            link="#"
            :subtitle="`${item.Articulo != null ? item.Articulo.Codigo : ''}`"
          >
            <template #title>
              <div>
                <span class="titlea">
                  {{ item.Articulo != null ? item.Articulo.Nombre : '' }}
                </span>
                <div class="btn-add-info-output-worker">
                  <img
                    v-if="!item.UbicadoEnUbicacionPorDefecto"
                    class="margin-left-half"
                    width="20"
                    alt="iconWarning"
                    src="@/static/icons/ic_warning.svg"
                  >
                  <img
                    class="content-list-queue-item__icon"
                    width="20"
                    alt="iconInfo"
                    src="@/static/img/ic_gallery.svg"
                    @click="OpenImagenesEntidad(item)"
                  >
                </div>
              </div>
            </template>

            <template #after>
              <div :class="item.CantidadPosicionada >= item.CantidadPosicionar ? 'item-after-complete' : 'item-after-incomplete'">
                {{
                  item.hasOwnProperty('CantidadPosicionada')
                    ? item.CantidadPosicionada
                    : 0
                }}
                de
                {{
                  item.hasOwnProperty('CantidadPosicionar')
                    ? item.CantidadPosicionar
                    : 0
                }}
              </div>
            </template>
          </f7-list-item>
        </template>
      </UCAcordeon>
    <!-- <pre> {{ locationList }}</pre> -->
    </div>

    <UCCodeScanner
      ref="UCCodeScannerShoppingLocation"
      :fab-button-show="false"
      :allow-manual-code-entry="true"
      :autofocus-on-input="true"
      @code-reading="CodeScannerReaded"
      @codigo-barras="CodeScannerReaded"
    />

    <!--
        <UCSearchEntityERP
          v-if="scanMode === enumScanMode.OTHERS"
          ref="UCOPurchaseOrder"
          placeholder="Albaran Compra"
          search-text="Buscando Albaran de Compra"
          search-cancellation-text="Búsqueda de albaran de compra cancelada…"
          search-not-found-text="Albraran de compra no encontrado…"
          :end-point-for-list="GetPurchaseOrders"
          :end-point-for-code-search="GetPurchaseOrders"
          :property-entity-shown-input="['Serie', 'Numero']"
          :property-entity-shown-list-title="['Serie', 'Numero']"
          :property-entity-shown-list-subtitle="['Proveedor.NombreProveedor']"
          :min-text-search="1"
          :autofocus-on-deselection="true"
          :auto-focus-on-empty-search-result="true"
          :qr-search-show="false"
          @selection="EventPurchaseOrderSelected"
        />
        -->

    <div class="content-button">
      <f7-button
        v-if="locationList != null"
        class="btn-confirmar"
        fill
        @click="EventOpenReadBarCodeForLocation()"
      >
        Escanear ubicación
      </f7-button>
    </div>

    <f7-popup
      class="frmManageShoppingLocation-popup-images"
      :opened="popupImagenes"
      @popup:closed="popupImagenes = false"
    >
      <f7-navbar
        :title="$t('common.files')"
        sliding
        :style="appTheme"
      >
        <f7-nav-right>
          <f7-link @click="popupImagenes = false">
            <img
              :src="icClose"
              style="padding-right: 10px;"
            >
          </f7-link>
        </f7-nav-right>
      </f7-navbar>
      <PCImagenesEntidad
        v-if="idEntidad != null"
        :is-active="popupImagenes"
        :entity-id="idEntidad"
        entity-type="Articulo"
        @open-pdf="popupImagenes = false"
      />
    </f7-popup>
  </f7-page>
</template>

<script>
import { mapState, mapWritableState } from 'pinia';
import { useAppConfigStore } from '@/js/stores/appConfig';
import { useInformationBar } from '@/composables/useInformationBar';
import { useCommercialisationStore } from '@/js/stores/commercialisation';
import { useParamRef } from '@erpagroapp/params';

import icDetail from '@/static/img/ic_detail.svg';
import icQr from '@/static/icons/ic_qr.svg';
import TheNavbar from '@/components/TheNavbar.vue';
import UCAcordeon from '@/components/common/UCAcordeon.vue';
import UCPreload from '@/components/common/UCPreload.vue';
import { callExecuteSPERP, callFetchWarehousesForEnterpriseGroupsAndLocations } from '@/js/services/APIErp';
import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import UCCodeScanner from '@/components/common/UCCodeScanner.vue';
import { TipoDocumento } from '@/js/common/enum';
import CommonController from '@/js/controllers/CommonController';
import UCEmptyList from '@/components/common/UCEmptyList.vue';
import PCImagenesEntidad from '@/components/production/traceability/PCImagenesEntidad.vue';
import icClose from '@/static/icons/ic_close.svg';
import { ConfirmDialogGH, HiNotification, PreloaderGH } from '@/js/common/HINotificationSupport';
import { f7 } from 'framework7-vue';
import { sleep } from '@/js/utils/sleep';

export default {
  name: 'FrmManageShoppingLocationIndex',

  components: {
    TheNavbar,
    UCAcordeon,
    UCPreload,
    UCCodeScanner,
    UCEmptyList,
    PCImagenesEntidad,
  },

  props: {
    // Código de barras de albaran de compra o lista de ubicaciones, se utiliza para ser llamado al inicializar el formulario.
    barCode: {
      type: String,
      default: '',
    },
  },

  setup() {
    const { shouldShowInformationBar } = useInformationBar();
    return {
      shouldShowInformationBar,
    };
  },

  data() {
    return {
      showPreload: false, // Mostrar preload
      itemAcordeonOpen: 0, // Item del acordeon abierto.
      scanMode: 0, // Modo de escaneo
      enumScanMode: {
        NONE: 0,
        LOCATION: 1, // Ubicación
        OTHERS: 2, // (Albaran de compra, Pedido de venta, Lista de Ubicaciones, Lista de ubicaciones para recolección)
      },
      idDocumentRead: null, // Id del documento leido (Albaran de compra o lista de ubicaciones)
      itemSelecte: null,
      popupImagenes: false,
      idEntidad: null, // id de la entidad a pasar a PCImagenes entidad
      icClose,
      typeOfDocumentRead: null, // Tipo de documento leido (albaran de compra o lista de ubicaciones).
      warehouse: [],
      disallowLocationAdvancement: useParamRef('NoPermitirAvanzarEnGestionUbicacionesAPP'),
    };
  },
  computed: {
    ...mapState(useAppConfigStore, [
      'userEnviroment',
    ]),

    ...mapWritableState(useCommercialisationStore, [
      'locationList', // Documento con la lista de ubicaciones de artículos de un albaran de compra.
      'locationSelected', // Ubicacion Seleccionada
      'locationsArticlesSelected', // Lista de artículos de una ubicacion seleccionada.
      'ResetFrmLocation',
    ]),

    appTheme() {
      return {
        '--f7-navbar-bg-color': 'var(--his-slate-blue)',
      };
    },
    iconDetail() {
      return icDetail;
    },
    iconQr() {
      return icQr;
    },
    estado() {
      let estado = 'Pendiente de Ubicar';
      let completado = true;
      this.locationList.Lineas.forEach((element) => {
        if (element.CantidadPosicionada !== 0) {
          estado = 'Parcialmente Ubicado';
        }
        if (element.CantidadPosicionada !== element.CantidadPosicionar) {
          completado = false;
        }
      });
      if (completado) {
        return 'Completado';
      }
      return estado;
    },

    /**
     * Returns the maximum height for the accordion.
     * @returns {string} The maximum height for the accordion, in percents.
     */
    maxAccordionHeight() {
      return this.shouldShowInformationBar ? '80%' : '88%';
    },
  },
  watch: {
    barCode(val) {
      if (val !== '') {
        this.CodeScannerReaded(val);
        // this.GetPurchaseOrders(e.substring(6, 12)); // 10009IIIIIIC
      }
    },
    ResetFrmLocation(val) {
      if (val) {
        this.ResetPage();
      }
    },
  },
  created() {
    this.ResetFrmLocation = false;
    this.StartComponent();
  },

  beforeUnmount() {
    this.EndComponent();
  },

  methods: {
    StartComponent() {
      Log(this, this.StartComponent.name);
      this.scanMode = this.enumScanMode.NONE;
      this.typeOfDocumentRead = TipoDocumento.ND;
      this.locationList = null;
      if (this.barCode !== '') {
        this.scanMode = this.enumScanMode.OTHERS;
        this.CodeScannerReaded(this.barCode);
      }
    },
    EndComponent() {
      Log(this, this.EndComponent.name);
      this.locationList = null;
      this.locationSelected = null;
      this.locationsArticlesSelected = null;
    },
    async ResetPage() {
      Log(this, this.ResetPage.name);
      PreloaderGH(true, true, 'Cargando', this.$t('common.updatingInformation'));
      // await this.GetPurchaseOrders(this.idDocumentRead);
      await this.GetMainData(this.idDocumentRead);
      if (this.itemSelecte && this.itemSelecte.length !== 0) {
        const las = this.locationList.Lineas.filter((e) =>/*  e.Id === this.itemSelecte[0].Id &&  */e.Ubicacion.Id === this.itemSelecte[0].Ubicacion.Id);
        this.locationsArticlesSelected = las;
      }
      this.ResetFrmLocation = false;
      PreloaderGH(false);
    },
    ubicacionCompleta(item) {
      let completado = true;
      item.items.forEach((element) => {
        if (element.CantidadPosicionada !== element.CantidadPosicionar) {
          completado = false;
        }
      });
      return completado;
    },
    async GetMainData(id) {
      Log(this, this.GetMainData.name);
      if (!this.ResetFrmLocation) {
        this.locationList = null;
      }
      this.idDocumentRead = id;
      this.showPreload = true;
      const temp = await this.Conections_GetMainData(id, this.typeOfDocumentRead === TipoDocumento.ALBARAN_COMPRA ? 1 : 0);

      if (temp === null) {
        HiNotification.Toast('No se encuentra la lista de ubicaciones');
        this.showPreload = false;
        return;
      }

      const validLines = temp.Lineas.filter((line) => line.Ubicacion !== null && line.Ubicacion.Id > 0);

      if (validLines.length === 0) {
        HiNotification.Toast('No hay líneas con ubicación establecida');
        this.showPreload = false;
        return;
      }

      const newRecords = [];

      // TODO HACER EL CAMBIO SIMULANDO QUE TENEMOS MAS DE UN REGISTRO
      validLines.forEach((i) => {
        i.MercanciaPosicionada.forEach(async (j) => {
          if (j.Ubicacion.Id !== i.Ubicacion.Id) {
            const nuevoRegistro = { ...i };
            nuevoRegistro.Ubicacion = j.Ubicacion;
            nuevoRegistro.CantidadPosicionada = j.Cantidad; // La cantidad en una ubicación diferente no es la total. Es la del AE.
            nuevoRegistro.CantidadPosicionar = j.Cantidad;
            nuevoRegistro.UbicadoEnUbicacionPorDefecto = j.UbicacionDefectoArticulo == null; // Se marcará como no ubicado en la ubicación por defecto si no esta ubicado en la ubicación por defecto y siempre que tengamos una ubicación por defecto para el artículo.
            newRecords.push(nuevoRegistro);
          }
        });
        if (!('UbicadoEnUbicacionPorDefecto' in i)) {
          i.UbicadoEnUbicacionPorDefecto = true;
        }
      });

      temp.Lineas = [...validLines, ...newRecords];

      // await this.AddWarehouse(temp);
      this.locationList = temp;

      if (!this.ResetFrmLocation && this.estado === 'Completado') {
        this.locationList = null;
        HiNotification.Toast('El Location List que intenta consultar está en estado completado');
      }
      this.showPreload = false;
    },

    async AddWarehouse(temp) {
      Log(this, this.AddWarehouse.name);

      try {
        const promises = temp.Lineas.map((line) => this.GetWarehouse(line.Ubicacion.Id));
        await Promise.all(promises);

        temp.Lineas.forEach((l) => {
          this.warehouse.forEach((w) => {
            if (l.Ubicacion.Id === w.clave) {
              [l.Ubicacion.Almacen] = w.data;
            }
          });
        });

        this.locationList = temp;
      } catch (error) {
        LogError(this, this.AddWarehouse.name, error);
      }
    },

    async BackToMain() {
      if (this.locationList != null) {
        const resultConfirm = await ConfirmDialogGH('Tienes una lista de ubicación de mercancía en curso. ¿Quieres salir del proceso?', 'Salir');
        if (!resultConfirm) {
          return;
        }
      }
      f7.views.main.router.clearPreviousHistory();
      f7.views.main.router.navigate('/', { force: true });
    },

    OpenImagenesEntidad(item) {
      this.idEntidad = item.Articulo.Id;
      this.popupImagenes = true;
    },
    NavigateToLocationDetails(location, item) {
      Log(this, this.NavigateToLocationDetails.name);
      this.locationSelected = location;
      this.itemSelecte = item;
      this.locationsArticlesSelected = item;
      f7.views.main.router.navigate('/warehouse/manageShoppingLocation/frmManageShoppingLocationDetails');
    },

    EventAcordeonSelected(value) {
      Log(this, this.EventAcordeonSelected.name);
      this.itemAcordeonOpen = value;
    },
    EventOpenReadBarCodeForLocation() {
      Log(this, this.EventOpenReadBarCodeForLocation.name);
      this.scanMode = this.enumScanMode.LOCATION;
      this.$refs.UCCodeScannerShoppingLocation.Open();
    },
    async EventOpenReadBarCode() {
      Log(this, this.EventOpenReadBarCode.name);
      this.scanMode = this.enumScanMode.OTHERS;
      if (this.locationList != null) {
        const resultConfirm = await ConfirmDialogGH('Tienes una lista de ubicación de mercancía en curso. ¿Quieres salir para leer otra lista?', 'Leer nueva lista de ubicación de mercancía');
        if (resultConfirm) {
          this.locationList = null;
        } else {
          return;
        }
      }
      this.$refs.UCCodeScannerShoppingLocation.Open();
    },
    async EventSelectedElemenParentAcordeon(e) {
      Log(this, this.EventSelectedElemenParentAcordeon.name);
      this.NavigateToLocationDetails(e.group, e.items);
    },

    async EventLocationSelected(e) {
      Log(this, this.EventLocationSelected.name);

      if (!e) {
        return;
      }

      // El popup de busqueda de ubicaciones tarda en cerrarse, por lo que se espera un poco para que no se cierre antes de que se cierre el popup de lectura de codigo.
      await sleep(200);
      this.$refs.UCCodeScannerShoppingLocation.ClosePopup();

      const lines = this.locationList.Lineas.filter((element) => element.Ubicacion.Id === e.Id);

      if (lines?.length > 0) {
        this.NavigateToLocationDetails(e, lines);
      } else {
        this.NavigateToLocationDetails(e, []);
      }
    },
    EventPurchaseOrderSelected(e) {
      Log(this, this.EventPurchaseOrderSelected.name);
      if (e !== null) {
        this.$refs.UCCodeScannerShoppingLocation.ClosePopup();
      }
    },

    async CodeScannerReaded(barCode) {
      Log(this, `${this.CodeScannerReaded.name} ${barCode}`);

      if (this.scanMode === this.enumScanMode.LOCATION) {
        const result = await this.GetLocationByFilter(`barcode:${barCode}`);

        if (result !== null && (result.statusText === 'OK' || result.status === 200) && result.data.length > 0) {
          this.EventLocationSelected(result.data[0]);
        } else {
          HiNotification.Toast('El código de barras de la ubicación no es correcto');
        }
      } else if (this.scanMode === this.enumScanMode.OTHERS) {
        this.typeOfDocumentRead = CommonController.DeterminateBarCodeType(barCode);

        if (this.typeOfDocumentRead === TipoDocumento.ALBARAN_COMPRA) { // 10009IIIIIIC
          this.GetPurchaseOrders(barCode.substring(6, 12));
        } else if (this.typeOfDocumentRead === TipoDocumento.LISTA_UBICACION) { // 10011IIIIIIC
          this.GetMainData(barCode.substring(6, 12));
        } else if (this.typeOfDocumentRead === TipoDocumento.PEDIDO_VENTA
          || this.typeOfDocumentRead === TipoDocumento.LISTA_UBICACION_PREPARACION
          || this.typeOfDocumentRead === TipoDocumento.PARTE_PRODUCCION) { // 10010IIIIIIC o 10012IIIIIIC o 100040IIIIIIC
          f7.views.main.router.navigate('/warehouse/manageSalesLocation/frmManageSalesLocation', {
            reloadCurrent: true, // Reemplaza la actual página con la nueva.
            props: {
              barCode,
            },
          });
        } else {
          HiNotification.Toast('El código de barras no es correcto');
        }
      }

      this.scanMode = this.enumScanMode.NONE;
    },

    ObtainLocationsWithSearchCriteria(e) {
      Log(this, this.ObtainLocationsWithSearchCriteria.name);
      return this.GetLocationByFilter(`q:${e}`);
    },

    GetLocationByFilter(filter) {
      Log(this, this.GetLocationByFilter.name);
      // return ConexionTA.callObtenerUbicacionPorCodigo(filter);
      return callExecuteSPERP(
        'APPERPAGRO_Ubicaciones',
        [{ NombreParametro: 'filtro', Valor: filter }],
        'Almacen.UbicacionJSON',
      );
    },

    async GetWarehouse(idUbicacion) {
      Log(this, this.GetWarehouse.name);

      await callFetchWarehousesForEnterpriseGroupsAndLocations({
        enterpriseGroupIds: [this.userEnviroment.EntornoDeTrabajo.GrupoEmpresarial.Id],
        locationIds: [idUbicacion],
      }).then((result) => {
        let band = false;
        this.warehouse.forEach((e) => {
          if (idUbicacion === e.clave) {
            band = true;
          }
        });

        if (!band) {
          this.warehouse.push({
            clave: idUbicacion,
            data: result.data,
          });
        }
      });
    },

    async GetPurchaseOrders(id) {
      Log(this, this.GetPurchaseOrders.name);
      this.showPreload = true;
      try {
        let result = null;
        if (id !== null && id !== undefined) {
          result = await callExecuteSPERP(
            'APPERPAGRO_AlbaranesCompra',
            [{ NombreParametro: 'filtro', Valor: `Ids:${id}` }],
            'Compras.AlbaranCompraJSON',
          );
          this.showPreload = false;
          if ((result.statusText === 'OK' || result.status === 200) && result.data.length > 0) {
            await this.GetMainData(result.data[0].Id);
            return result.data[0];
          }
          HiNotification.Toast('El albarán de compra no existe');
          return null;
        }
      } catch (error) {
        LogError(this, this.GetPurchaseOrders.name, error);
        this.showPreload = false;
        return null;
      }
      return null;
    },
    /* Metodo que obtiene el albaran de compra por código */
    async Conections_GetMainData(id, typeOfDocument) {
      Log(this, this.Conections_GetMainData.name);
      try {
        /*
        const result = await callExecuteSPERP('APPERPAGRO_LocationListXAlbaranCompra',
          [{ NombreParametro: 'codigo', Valor: id }],
          'Almacen.UbicacionesArticulosAlbaranCompra');
        */

        const result = await callExecuteSPERP(
          'APPERPAGRO_ListaDeUbicaciones',
          [
            { NombreParametro: 'idDocumento', Valor: id },
            { NombreParametro: 'tipoDocumento', Valor: typeOfDocument },
          ],
          'Almacen.ListaDeUbicacionesJSON',
        );
          // 'Almacen.UbicacionesArticulosAlbaranCompra');

        if ((result.statusText === 'OK' || result.status === 200) && result.data.length > 0) {
          return result.data[0];
        }
      } catch (error) {
        LogError(this, this.Conections_GetMainData.name, error);
      }
      return null;
    },
  },

};
</script>

<style lang="scss">
.main-frmManageShoppingLocation {
  .page-content {
    // It is necessary because there is a fixed button in the footer
    max-height: v-bind(maxAccordionHeight);

    // This is for correct visualization of the acordion list because there is a fixed header
    padding-top: calc(var(--f7-page-navbar-offset) + 81px);

    @media (max-width: 312px) {
      padding-top: calc(var(--f7-page-navbar-offset) + 102px);
    }
  }

  .limit-line {
    -webkit-box-orient: vertical;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
  }

  .content-accordion {
    .storybook-action-sorted-accordion {
      .accordion-list {
        .accordion-item {
          margin-bottom: -2px;

          .item-inner {
            border-bottom: 1px solid var(--his-light-blue);

            .item-content {
              background: var(--his-slate-blue);

              .item-title {
                color: var(--his-light-blue);
                font-weight: 600;
                font-size: 15px;
                display: flex;
                align-items: center;
              }
            }
          }
        }

        ul {
          .accordion-item-opened {
            .item-inner {
              border-bottom: 1px solid var(--his-light-blue);

              .item-content {
                .item-after {
                  background-color: var(--his-slate-blue) !important;
                }

                .item-title {
                  color: var(--his-light-blue);
                }
              }
            }

            .item-link {
              &::after {
                border-top: 0;
              }

              .item-content {
                background-color: #fff;
                padding-right: 5px;
              }
            }
          }
        }
      }

      .accordion-item-content {
        --f7-list-item-title-text-color: var(--his-dark-blue);
        --f7-list-item-title-font-size: 16px;
        --f7-list-media-item-title-font-weight: 600;
        --f7-list-item-after-font-size: 11px;
        --f7-list-item-after-text-color: #ba5333;
        --f7-list-item-after-font-weight: 500;
        --f7-list-item-subtitle-font-size: 11px;
        --f7-list-item-subtitle-line-height: 1.8;
        --f7-list-item-subtitle-text-color: var(--his-oliva);
        --f7-list-item-text-font-size: 11px;
        --f7-list-item-text-text-color: var(--his-ash-gray);
        --f7-list-item-text-line-height: 1;
        --f7-list-chevron-icon-color: var(--his-oliva);

        .item-title-row {
          align-items: center;
        }

        .item-subtitle {
          display: flex;
          justify-content: space-between;

          .btn-add-info-output-worker {
            margin-top: 5px;
            padding-right: 40px;
          }
        }

        .item-title {
          /* display: flex;
            justify-content: flex-end;
            flex-direction: row-reverse; */
          div {
            display: flex;
            justify-content: flex-end;
            flex-direction: row-reverse;

            .titlea {
              -webkit-box-orient: vertical;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: normal;
              margin-top: 2px;
            }

            .btn-add-info-output-worker {
              margin-right: 10px;
            }
          }
        }

        /* .item-after{
            background-color: var(--his-mandarina-tint);
            padding: 4px 8px;
            border-radius: 3px;
          } */
      }
    }
  }

  .storybook-action-sorted-accordion {
    .list:not(.media-list) > ul > .accordion-item:not(.media-item) > .item-inner > .item-link::before {
      // color: var(--his-slate-blue)!important;
      display: none;
    }
  }

  .item-after-complete {
    background-color: var(--his-greensoft);
    color: var(--his-greendark);
    padding: 4px 8px;
    border-radius: 3px;
  }

  .item-after-incomplete {
    background-color: var(--his-mandarina-tint);
    padding: 4px 8px;
    border-radius: 3px;
  }

  .disabled {
    opacity: 0.6;
    pointer-events: none;
  }

  .header {
    position: fixed;
    top: var(--f7-navbar-height);
    z-index: 10;
    width: 100%;
    background: var(--his-oliva);

    span {
      color: #fff;
    }

    &__title {
      margin-left: 8px;
      font-size: 12px;
      opacity: 0.8;
    }

    &__texto {
      font-size: 14px;
      display: flex;
      flex-direction: row;
      margin-left: 10px;
      justify-content: space-between;

      @media (min-width: 767px) {
        width: 40%;
      }

      @media (max-width: 767px) {
        width: 95%;
      }

      &--title {
        min-width: 35%;
      }

      &--margin {
        width: 65%;
        -webkit-box-orient: vertical;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
      }
    }
  }

  .content-button {
    position: fixed;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    bottom: 0;
    margin-bottom: calc(25px + var(--information-bar-height));

    .button {
      width: 90%;
      --f7-button-pressed-bg-color: var(--his-slate-blue);
      --f7-button-bg-color: var(--his-green);
    }
  }
}

.escanerCodigoBarras-popup {
  .page {
    .page-content {
      .slot-codeScanner {
        margin: 15px;
      }
    }
  }
}

.frmManageShoppingLocation-popup-images {
  overflow-y: scroll;
}
</style>
